<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Tarification Colis Postaux" />
            <ProduitColisPostaux />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'
import ProduitColisPostaux from '../Services/ProduitColisPostaux'
import FooterComp from '../Layouts/FooterComp'

export default {
    name: 'ProduitColisPostauxPage',
    components: {
        NavBar,
        PageTitle,
        ProduitColisPostaux,
        FooterComp,
    }
}
</script>